import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div<{ color: string }>`
  ${({ color }) => css`
    position: relative;
    background: ${color};
    border-left: 1px solid ${color};
    border-right: 1px solid ${color};
    &:before {
      content: '';
      background: ${color};
      /* same value as Content's padding */
      width: 8px;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      transform: translateX(-100%);
    }

    &:after {
      content: '';
      background: ${color};
      /* same value as Content's padding */
      width: 0;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      transform: translateX(100%);
    }

    @media (min-width: ${tokens.breakpoints.tablet}px) {
      &:before {
        width: calc(50dvw - 50%);
      }

      &:after {
        width: calc(50dvw - 50%);
      }
    }
  `}
`
